<!-- Filter Datatables -->
<section id="ngx-datatable-filter">
    <div class="row">
      <div class="col-12"></div>
      <div class="col-12">
        <div class="card">
          <div class="card-content">
            <div class="card-body">
              <!-- ngx-datatable-filter -->
              <fieldset class="form-group">
                <div class="row align-items-end mt-0 pagination-body">
                  
                  <div class="col-12 col-sm-12 col-md-6 col-lg-6 mt-2 mb-1">
                    <div class="btn-group" role="group">
                      <button class="btn enrollment-list-buttons cursor-pointer" type="button"
                      *ngFor="let type of list_type"
                      [ngClass]="{'btn-primary':activeTab == type?.name,'btn-outline-primary':activeTab!=type?.name}"
                      (click)="activeCheckListTab(type?.name)">{{type.displayname}}</button>
                    </div>
                  </div>
                  <div class="col-12 col-sm-12 col-md-6 col-lg-6 mt-2 mb-1">
                    <div class="row-flex">
                      <div class="col-flex-2 mb-1 position-relative">
                        <input id="ngx-filter-ref"
                          class="form-control form-control-sm d-inline-block width-300 ml-1 rounded-right shadow searchInput"
                          type="text" placeholder="Search" #name [(ngModel)]="searchVal"
                          (keydown.enter)="getCategoryFilter(searchVal)" />
                        <button class="btn search-btn glow position-absolute" (click)="getCategoryFilter(searchVal)">
                          <i class="ft-search text-white cursor-pointer"></i>
                        </button>
                      </div>
                      <div class="col-flex-2 mb-1">
                        <button class="btn btn-primary btn-block users-list-clear glow mb-0" (click)="resetFilter()">Reset
                          <i class="ft-filter text-white cursor-pointer"></i>
                        </button>
                      </div>
                      <div class="col-flex-2 mb-1"
                        *ngIf=" user_role.roles =='admin' || user_role.roles =='employee' || user_role.roles =='extractor'">
                        <button type="reset" class="btn btn-primary btn-block users-list-clear glow mb-0"
                          routerLink="/checklist/add" placement="top" ngbTooltip="Add New">
                          +
                        </button>
                      </div>
                    </div>
                  </div>
                  <ngx-datatable class="bootstrap core-bootstrap" [columnMode]="ColumnMode.force" [headerHeight]="40"
                    [footerHeight]="40" rowHeight="auto" [limit]="limitRef" [rows]="rows" [externalPaging]="true"
                    [count]="page.totalPages" [offset]="page.pageNumber" (page)="pageChangeData($event)"></ngx-datatable>
                    <div class="col-12">
                      <button *ngIf="guideline_data" class="btn btn-outline-primary" (click)="openDynamicModal(guideline_data)">Checklist Guideline</button>
                      </div>
                </div>
  
              </fieldset>
              <ngx-datatable class="bootstrap core-bootstrap" [columnMode]="ColumnMode.force" [headerHeight]="50"
                [footerHeight]="50" rowHeight="auto" [limit]="limitRef" [rows]="rows" [scrollbarH]="true"
                [columns]="columns" [externalPaging]="true" [count]="page.totalPages" [offset]="page.offset"
                (page)="pageChangeData($event)">
                <ngx-datatable-column name="Display Name" prop="displayname" [width]="140">
                  <ng-template let-row="row" let-name="value" ngx-datatable-cell-template>
                    <div class="d-flex align-items-center">
                      <!-- <img class="rounded-circle mr-1" *ngIf="row.image" [src]="imageUrl + row.image" height="32"
                        width="32" />
                      <div *ngIf="!row.image" class="avatar mr-1 ml-0 bg-primary">
                        <div class="avatar-content">{{ row?.displayname }}</div>
                      </div> -->
  
                      <!-- <div class="cell-line-height">
                        <a class="line-height-1 mb-0">{{ row.categoryName }}</a>
                      </div> -->
                      <div class="cell-line-height" >
                        <p class="font-medium-1 line-height-1 mb-0 cursor-pointer"
                          [routerLink]="['/categories/category-view', row._id]" (click)="editCategory(row._id)">
                          {{ row.displayname }}
                        </p>
                        <!-- <span class="text-muted font-small-2">
                          Nuclear Power Engineer</span
                        > -->
                      </div>
                      <!-- <div class="cell-line-height" *ngIf="row?.type[0]?.displayname =='Quick'" >
                        <p class="font-medium-1 line-height-1 mb-0 cursor-pointer json-data" (click)="openPopup(myModalValue,row?._id,row?.sprint)">
                          {{ row?.sprint[0]?.data | json }}
                        </p>
                      </div> -->
                    </div>
                  </ng-template>
                </ngx-datatable-column>
                <!-- <ngx-datatable-column name="Name" prop="name" [width]="150"></ngx-datatable-column> -->
                <!-- <ngx-datatable-column name="Last Activity" prop="Last Activity" [width]="120"></ngx-datatable-column> -->
                <!-- <ngx-datatable-column name="Verified" prop="Verified" [width]="70"></ngx-datatable-column> -->
                <ngx-datatable-column name="Description" prop="description" [width]="100"></ngx-datatable-column>
                <ngx-datatable-column name="checklist" prop="checklist" [width]="70">
                  <ng-template let-row="row" ngx-datatable-cell-template>
                    <p (click)="openDataModel(checklistDataModal,row?.sprint[0]?.checklist,row?.sprint[0]?._id,row?.sprint[0]?.sprint_data[0]?._id)">Checklist Link</p>
                  </ng-template>
                </ngx-datatable-column>
                <!-- <ngx-datatable-column name="Body" prop="body" [width]="70"></ngx-datatable-column> -->
                <ngx-datatable-column name="Notes" prop="notes" [width]="60"></ngx-datatable-column>
                <ngx-datatable-column name="Type" prop="type"[width]="10">
                  <ng-template let-row="row" ngx-datatable-cell-template>
                    <span *ngFor="let type of row?.type; last as isLast">
                      {{type.displayname}}
                      <span *ngIf="row?.emp_type.length>1 && !isLast">,</span>
                    </span>
                  </ng-template>
                </ngx-datatable-column>
                <ngx-datatable-column name="Actions"
                  *ngIf=" user_role.roles =='admin' || user_role.roles =='employee' || user_role.roles =='extractor'">
                  <ng-template let-row="row" ngx-datatable-cell-template>
                    <i class="ft-edit text-primary cursor-pointer mr-2"
                      [routerLink]="['/checklist/edit', row._id]"></i>
                    <i *ngIf="user_role.roles =='admin'" class="ft-trash-2 cursor-pointer danger"
                      (click)="ConfirmColor(row._id)"></i>
                  </ng-template>
                </ngx-datatable-column>
              </ngx-datatable>
              <!-- ngx-datatable-filter -->
            </div>
          </div>
        </div>
      </div>
    </div>
  </section>
  <!--/ Filter Datatables -->
  <div class="d-flex justify-content-between align-items-center">
    <ngx-spinner></ngx-spinner>
  </div>

<!-------------- Sprint Value Update  Popup ------------------------------------------->
<div>
  <ng-template #myModalValue let-modal>
    <div class="modal-header">
      <h4 class="modal-title">Json Update</h4>
      <button type="button" class="close" (click)="modal.dismiss()">
        <span>&times;</span>
      </button>
    </div>
    <div class="modal-body">
      
      <div *ngFor="let key of row_json_dataa">
        <label>{{key | titlecase}}</label>
        <input type="text" class="form-control" id="{{key}}" name="{{key}}" [(ngModel)]="row_json_data[key]">
      </div>
    </div>
    <div class="modal-footer">
      <button type="button" class="btn btn-primary" (click)="updateValue()">Update</button>
      <button type="button" class="btn btn-secondary" (click)="modalService.dismissAll()">Cancel</button>
      </div>
  </ng-template>
</div>

<!---------- CheckList Data  Popup ---------------->
<div>
	<ng-template #checklistDataModal let-modal>
		<div class="modal-header">
			<h4 class="modal-title">Checklist Data</h4>
			<button type="button" class="close" (click)="modal.dismiss()">
				<span>&times;</span>
			</button>
		</div>
		<div class="modal-body">
      <div *ngFor="let item of key_Values; let i = index" class="key-value-input d-flex">
        <input class="input-key" type="text" placeholder="Key" [(ngModel)]="item[0]" name="key_{{i+1}}" [ngModelOptions]="{ standalone: true }">
        <input class="input-value" type="text" placeholder="Value" [(ngModel)]="item[1]" name="value_{{i+1}}" [ngModelOptions]="{ standalone: true }">
        <button class="btn btn-primary mb-1" (click)="removeItem(i)">-</button>
      </div>
      <button  class="btn btn-primary" (click)="addItem()">+</button>
    </div>
    <div class="modal-footer">
		<button type="button" class="btn btn-primary" (click)="updateCheck()">Submit</button>
		<button type="button" class="btn btn-secondary" (click)="modalService.dismissAll()">Cancel</button>
	</div>
  </ng-template>
</div>